import React, { Fragment, ReactNode, useImperativeHandle, useRef } from 'react'
import { Float } from '@headlessui-float/react';
import type { Placement } from '@floating-ui/dom';
import { Popover, Transition } from '@headlessui/react'

interface PopoverLayoutProps {
  toggler: ReactNode;
  children: ReactNode;
  togglerClass?: string;
  placement?: Placement;
  menuClass?: string;
  popoverRef: any;
}
export type PopoverRefType = {
  closeDropdown:()=>void
}

const PopoverLayout = React.forwardRef<PopoverRefType, PopoverLayoutProps>(({ 
  children, toggler, togglerClass, placement, menuClass, popoverRef }: PopoverLayoutProps,
  ref) => {
 
    const closePopoverRef = useRef<any>(null);
    useImperativeHandle(ref, () => ({

        closeDropdown() {
          closePopoverRef.current?.click();
           
        }
    })); 


  return (
    <Popover className="relative flex items-center"  >
      {({ open, close }) => (
        <>
          <button hidden onClick={close} ref={closePopoverRef}></button>
          <Float placement={placement} ref={popoverRef} >
            <Popover.Button onClick={close} className={togglerClass ?? ''}>
              {toggler}
            </Popover.Button>
            <Transition
            
              as={Fragment}
              enter="transition ease-out duration-200"
              enterFrom="opacity-0 translate-y-1"
              enterTo="opacity-100 translate-y-0"
              leave="transition ease-out duration-200"
              leaveFrom="opacity-100 translate-y-0"
              leaveTo="opacity-0 translate-y-1"
            >
              <Popover.Panel className={menuClass ?? ''} onClick={close}>
                {children}
              </Popover.Panel>
            </Transition>
          </Float>
        </>
      )}
    </Popover>
  )
})

export default PopoverLayout